// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

// ** API Imports
import axios from '@src/service/axios';

import { toast } from 'react-toastify';

export const getFinancialYear = createAsyncThunk('financialyearSlice/getFinancialYear', async () => {
    try {
        let response = await axios.get('/FinancialYear', {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        return Promise.resolve(response?.data);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        console.log('err', err);
        return Promise.reject(err);
    }
});
export const getFinancialYearStatus = createAsyncThunk('financialyearSlice/getFinancialYearStatus', async () => {
    try {
        let response = await axios.get('/FinancialYear?status=true', {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        return Promise.resolve(response?.data);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        console.log('err', err);
        return Promise.reject(err);
    }
});
export const deleteFinancialYear = createAsyncThunk('financialyearSlice/deleteFinancialYear', async (deleteId, { dispatch }) => {
    try {
        let response = await axios.delete('/FinancialYear/' + deleteId, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        toast.success(response?.data?.message || 'DayAdjustment deleted successfully.');
        await dispatch(getFinancialYear());
        return Promise.resolve(response);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        console.log('err', err);
        return Promise.reject(err);
    }
});

export const createFinancialYear = createAsyncThunk('financialyearSlice/createFinancialYear', async (data, { dispatch }) => {
    try {
        let response = await axios.post('/FinancialYear', data, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        toast.success(response?.data?.message || 'DayAdjustment added succesfully.');
        await dispatch(getFinancialYear());
        return Promise.resolve(response);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        console.log('err', err);
        return Promise.reject(err);
    }
});

export const updateFinancialYear = createAsyncThunk('financialyearSlice/updateFinancialYear', async (data, { dispatch }) => {
    try {
        let response = await axios.put('/FinancialYear/' + data?.id, data?.data, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        toast.success(response?.data?.message || 'DayAdjustment updated succesfully.');
        await dispatch(getFinancialYear());
        return Promise.resolve(response);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        console.log('err', err);
        return Promise.reject(err);
    }
});

export const updateFinancialYearStatus = createAsyncThunk('financialyearSlice/updateFinancialYearStatus', async (id, { dispatch }) => {
    try {
        let response = await axios.put('/FinancialYear/status/' + id, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        toast.success(response?.data?.message || 'Status Updated Succesfully');
        await dispatch(getFinancialYear());
        return Promise.resolve(response);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        console.log('err', err);
        return Promise.reject(err);
    }
});
export const financialyearSlice = createSlice({
    name: 'financialyearSliceliceData',
    initialState: {
        financialyear: [],
        dayAdjustment: [],
        financialyearStatus: []
    },
    extraReducers: (builder) => {
        builder.addCase(getFinancialYear.fulfilled, (state, action) => {
            state.financialyear = action?.payload;
            return;
        });
        builder.addCase(getFinancialYearStatus.fulfilled, (state, action) => {
            state.financialyearStatus = action?.payload;
            return;
        });
    }
});

export default financialyearSlice.reducer;
